/**
 * Finance rounding constants for bills and invoices
 */

export const FINANCE_ROUNDING_TOTAL_DECIMAL_PLACES = 2;
export const FINANCE_ROUNDING_HOURS_DECIMAL_PLACES = 4;
export const FINANCE_ROUNDING_EFFECTIVE_RATE_DECIMAL_PLACES = 8;

export const FINANCE_MAX_DECIMAL_PLACES = 4;
export const FINANCE_MAX_INTEGER_DIGITS = 15;
